import { Route, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import HomeLayout from "./layouts/HomeLayout";
import NewInvoice from "./views/newInvoice/NewInvoice";

export const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route element={<HomeLayout />}>
                <Route path="/" element={<NewInvoice />} />
                {/* <Route path="/success" element={<Success />} />
                <Route
                    path="/review-vendor/:validateToken"
                    element={<VendorDetails />}
                />
                <Route
                    path="/update-vendor/:validateToken"
                    element={<VendorRegistration />}
                />
                <Route
                    path="/review-skus/:validateToken"
                    element={<VerifySKUs />}
                />
                <Route
                    path="/review-po/:validateToken"
                    element={<ReviewPO />}
                />
                <Route
                    path="/admin"
                    element={<AuthLayer />}
                    loader={() => defer({ userPromise: getUserData() })}
                >
                    <Route element={<AuthLayout />}>
                        <Route path="login" element={<Login />} />
                        <Route path="" element={<Main />} />
                        <Route
                            path="vendor-registration"
                            element={<VendorRegistration />}
                        />
                        <Route path="po-records" element={<PORecords />} />
                        <Route path="po-records/:poCode" element={<Reconcillation />} />
                        <Route
                            path="new-skus/:vendorCode"
                            element={<AddSKUs />}
                        />
                        <Route
                            path="new-buying-order/:vendorCode"
                            element={<AddBuyingOrder />}
                        />
                        <Route
                            path="vendor/:vendorCode"
                            element={<VendorDetails />}
                        />
                    </Route>
                </Route> */}
            </Route>
        </>
    )
);
